import { ChangeDetectorRef, Component, inject, OnInit, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    AppEnvironment,
    EnvironmentStatusService,
} from '@/app/shared/services/environment-status.service';

@Component({
    selector: 'app-environment-banner',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div
            *ngIf="
                appEnvironment === 'development' ||
                appEnvironment === 'test'
            "
            class="environment-banner"
            [ngClass]="{
                'environment-banner--development':
                    appEnvironment === 'development',
                'environment-banner--test':
                    appEnvironment === 'test'
            }"
        >
            <ng-container *ngIf="appEnvironment === 'development'">
                DEVELOPMENT ENVIRONMENT
            </ng-container>

            <ng-container *ngIf="appEnvironment === 'test'">
                TEST ENVIRONMENT
            </ng-container>
        </div>
    `,
    styles: [`
               
            .environment-banner {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                box-sizing: border-box;
                padding: 9px 16px;
                text-align: center;
                font-size: 13px;
                font-weight: 700;
                letter-spacing: 0.4px;
                z-index: 1100;
            }

            .environment-banner--development {
                background-color: #f59e0b;
                color: #422006;
            }

            .environment-banner--test {
                background-color: #16a34a;
                color: #ffffff;
            }

            
    `],
})
export class EnvironmentBannerComponent implements OnInit {
    private readonly environmentService =
        inject(EnvironmentStatusService);

    private readonly cdr = inject(ChangeDetectorRef);

    appEnvironment: AppEnvironment | null = null;

    ngOnInit(): void {
        this.environmentService.getEnvironment().subscribe({
            next: (response) => {
                this.appEnvironment = response.environment;
                this.updateBannerLayout(this.appEnvironment);
                this.cdr.detectChanges();
            },
            error: (error) => {
                console.error(
                    'Failed to retrieve application environment',
                    error,
                );
                this.appEnvironment = null;
                this.updateBannerLayout(null);
                this.cdr.detectChanges();
            },
        });
    }

    private readonly renderer = inject(Renderer2);

    private updateBannerLayout(environment: AppEnvironment | null): void {
        const showBanner =
            environment === 'development' ||
            environment === 'test';

        if (showBanner) {
            this.renderer.addClass(
                document.body,
                'has-environment-banner'
            );
        } else {
            this.renderer.removeClass(
                document.body,
                'has-environment-banner'
            );
        }
    }

    ngOnDestroy(): void {
        this.renderer.removeClass(
            document.body,
            'has-environment-banner'
        );
    }
}